import styled from "styled-components";
import { media } from "../../theme/theme";
import { V3HeadlineH3 } from "../Typography";
import { V3BodyGrey48 } from "../ReusableStyledComponents";
import { ClampMixin, ClampMixinType } from "../ReusableStyledComponents/ClampMixin";
import { AuthoryColorSchemeProps, getFontColor, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";
import { hexToRgba } from "../../utils/hexToRGBA";
import { CUSTOM_FONT_SET_SIZES } from "../../utils/getFontSetLabels";

export const CollectionListWrapper = styled.div`
    position: relative;
    height: 100%;
`;

export const CCWrapper = styled.div<{  $isSorting: boolean, $isAddCTA: boolean, $forceHover: boolean, $isProfile: boolean, $skipUserThemable?: boolean}>`
    padding: 12px 12px 16px;
    border: 1px ${({ $isSorting, theme }) => theme ? `${$isSorting ? 'dashed' : 'solid'} ${theme.v3.colors.grey88}` : null};
    border-radius: 10px;
    height: 100%;
    min-height: ${({ $isProfile}) => $isProfile  ? "248px" : "282px"};
    position: relative;
    box-shadow: ${({ $forceHover, theme,  $skipUserThemable }) =>  $forceHover ? `0px 8px 20px ${$skipUserThemable ? "rgba(0, 0, 0, 0.2)" : hexToRgba(getFontColor(theme.customization.backgroundColor), 0.2)}` : undefined};

    &:hover {
        cursor: ${({ $isSorting, $isAddCTA }) => !$isSorting && !$isAddCTA ? "pointer" : undefined};
        box-shadow: ${({ $isSorting, $isAddCTA, theme, $skipUserThemable}) => !$isSorting && !$isAddCTA ? `0px 8px 20px ${$skipUserThemable ? "rgba(0, 0, 0, 0.2)" : hexToRgba(getFontColor(theme.customization.backgroundColor), 0.2)}` : undefined};
    }
`;

export const CCCardGrabPos = styled.div`
    position: absolute;
    bottom: 15px;
    right: 15px;
`;

export const CCADDCTAWrapper = styled(CCWrapper)`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const CCPreviewImagesWrapper = styled.div<{ $color?: string, $image?: string, $imageLoaded?: boolean }>`
    display:flex;
    width: 100%;
    border-radius: 6px;
    height: 100px;
    opacity: ${({ $imageLoaded }) => $imageLoaded ? 1 : 0};
    overflow: hidden;
    position: relative;
    transition: opacity .3s ease;
    background: ${({ theme, $color, $image }) => {
        if ($image) return `url(${$image}) center center / cover no-repeat`;
        if ($color) return $color;
        return theme.v3.colors.grey96;
    }};
    border: ${({  $color, $image }) => {
        if ($image || $color) return;
        return "1px solid white";
    }};
`;

export const CCPreviewImage = styled.div<{ src: string, $imageLoaded?: boolean }>`
    width: 100px;
    height: 100px;
    background: url(${({ src }) => src}) center center / cover no-repeat grey;
    border-right: 2px solid white;
    opacity: ${({ $imageLoaded }) => $imageLoaded ? 1 : 0};
    transition: opacity .3s ease;
`;

export const HeadLineFavWrapper = styled.div`
    display: flex;
    align-items: center;
    max-width: 100%;

    > div {
        display: inline-flex;

        &:first-child {
            margin-right: 10px;  
            max-width: calc(100% - 26px);
        }
    }
`;

export const CollectionCardBottomInfoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
`;

export const CollectionCardsWrapper = styled.div<{ $bpSmall: number;  $bpLarge:number} >`
    display: flex;
    flex-wrap: wrap;

    > div {
        width: 100%;
        margin-bottom: 24px;
        margin-right: 18px;

        ${({ $bpSmall }) => media.custom($bpSmall)} {
            width: calc(50% - 9px);

            &:nth-child(2n) {
                margin-right: 0;
            }
        }

        ${({ $bpLarge }) => media.custom($bpLarge)} {
            width: calc(33.3% - 12px);

            &:nth-child(3n) {
                margin-right: 0;
            }

            &:not(:nth-child(3n)) {
                margin-right: 18px;
            }
        }
    }
`;

export const CCCardAddCTAWRapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const UserThemableCCCardDescription = styled(V3BodyGrey48)<{ $allowUserThemable: boolean } & AuthoryColorSchemeProps>`
    ${({ $allowUserThemable }) => $allowUserThemable && UserThemableHeading}
    font-size: ${({ theme,  $allowUserThemable }) => {
        if (!$allowUserThemable) return undefined;
        if (CUSTOM_FONT_SET_SIZES.includes(theme.customization.profileFontSet)) {
            return "15px";
        }
    }};
`;

export const CCCardDescription = styled(UserThemableCCCardDescription) <ClampMixinType>`
    ${ClampMixin}
    min-height: 36px;
    font-weight: 400;
`;

export const CCCardDescriptionPlaceholder = styled(CCCardDescription) <ClampMixinType>`
    color: ${({ theme }) => theme ? theme.v3.colors.grey70 : null};
`;

const UserThemableCCCardTitle = styled(V3HeadlineH3)<{ $allowUserThemable: boolean } & AuthoryColorSchemeProps>`
    ${({ $allowUserThemable }) => $allowUserThemable && UserThemableHeading}
`;

export const CCCardTitle = styled(UserThemableCCCardTitle) <ClampMixinType & { $allowUserThemable: boolean }>`
    ${ClampMixin}
`;

export const CCPreviewIconPlacer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const ReorderHint = styled(V3BodyGrey48)`
    display: flex;
    align-items: center;
    min-height: 42px;
`;
